import { updateTagLink } from 'api/Tags';

import { iaRa } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';

const mergeTags = (existingTags, newTags, mode) => {
  let updatedTags = structuredClone(existingTags || []);
  if (mode === 'remove') {
    updatedTags = updatedTags.filter((tag) => !newTags.some((r) => r.tag_id === tag?.tag_id));
  }
  if (mode === 'add') {
    const addedTags = newTags?.flatMap((t) => t);
    const uniqueTags = addedTags.filter(
      (newTag) => !updatedTags.some((existing) => existing?.tag_id === newTag?.tag_id)
    );
    updatedTags = [...updatedTags, ...uniqueTags];
  }
  if (mode === 'update') {
    const addedTags = newTags?.flatMap((t) => t);
    const filterOldPositions = updatedTags?.filter(
      (tag) => !addedTags.some((addedTag) => addedTag?.tag_id === tag?.tag_id)
    );
    updatedTags = [...filterOldPositions, ...addedTags];
  }
  return updatedTags;
};

const toQueryKey = (key) => (Array.isArray(key) ? key : [key]);

const invalidateKey = (queryClient, key) => queryClient.invalidateQueries(toQueryKey(key));

export const updateTagLinks = async ({
  navigate = null,
  queryClient = null,
  id = null,
  tags = [],
  mode = '',
  query = {},
  fromTable = false,
  refTable = '',
  isInvalidate = false
}) => {
  try {
    const result = await updateTagLink(navigate, {
      id,
      tags,
      mode,
      refTable
    });
    if (result?.code === 0) {
      if (!fromTable) {
        const queryUpdate = (oldData) => {
          try {
            const newData = oldData?.[query?.object]?.map((p) => {
              if (p?.id !== parseInt(id)) {
                return p;
              }

              const updatedTags = mergeTags(p?.tagLinks, result?.tags, mode);

              return {
                ...p,
                tagLinks: updatedTags
              };
            });

            return {
              ...oldData,
              [query?.object]: newData
            };
          } catch (error) {
            showAlert({
              title: "Couldn't update tags",
              message: error ?? 'Something went wrong',
              color: 'danger'
            });
          }
        };
        if (!isInvalidate) {
          if (query.multiple) {
            query?.keys?.forEach((key) => {
              queryClient.setQueriesData(toQueryKey(key), queryUpdate);
            });
          } else {
            queryClient.setQueriesData(toQueryKey(query?.keys), queryUpdate);
          }
        } else {
          if (query.multiple) {
            query?.keys?.forEach((key) => invalidateKey(queryClient, key));
          } else {
            invalidateKey(queryClient, query?.keys);
          }
        }
      } else {
        if (query.multiple) {
          query?.keys?.forEach((key) => invalidateKey(queryClient, key));
        } else {
          invalidateKey(queryClient, query?.keys);
        }
      }

      iaRa(query?.invalidateKeys).forEach((key) => invalidateKey(queryClient, key));
    }
  } catch (error) {
    showAlert({
      title: "Couldn't update tags",
      message: error ?? 'Something went wrong',
      color: 'danger'
    });
  }
};
